import dayjs from "dayjs";

export const DATES_TEXT = (fromDate: Date, untilDate: Date) =>
  `${dayjs(fromDate).format("MMM D")} - ${dayjs(untilDate).format("MMM D")}`;

export const CHANGE_DATES = "Change Dates";
